import jQuery from "jquery";

export default function validatePasswordOn(inputSelector) {
  var password     = jQuery(inputSelector);
  var confirmation = jQuery(inputSelector + '_confirmation');
  var element = confirmation.parent();
  var subtext = element.find('.help-block');

  var errorCheck = function(evt) {
    // If confirmation has not been filled, do nothing
    if (confirmation.val().trim() === '') {
      return true;
    }

    if (password.val() === confirmation.val()) {
      element.removeClass('has-error');
      subtext.addClass('hide');
    } else {
      element.addClass('has-error');
      subtext.removeClass('hide');
    }
    return true;
  };

  confirmation.on('focusout', errorCheck);
  password.on('focusout', errorCheck);
}
